import Fields from '@components/fields'
import Row from '@components/row'
import Typography from '@components/typography'
import { StyleCard } from './style'
import Svg from '@components/svg'
const PasswordCard = () => {
  return (
    <Row
      styleRow="border-radius:12px;padding:15px 20px;flex-flow:row wrap;"
      rowGap={15}
      colGap={20}
      bg="white"
      justifyContent="space-between"
    >
      <Row alignItems="center" colGap={20}>
        <Typography
          content="Set Password For Login"
          size={14}
          styleText="white-space:nowrap"
          weight={400}
        />
        <Fields.Password
          name="password"
          placeholder="Password"
          styleWrapper="flex:1"
          styleInput="width:250px;"
        />
      </Row>
      <StyleCard>
        <Svg svg="light" />
        <Typography
          content="System will generate Password and Sent to Registered Email if kept Empty"
          size={12}
          tc="text"
        />
      </StyleCard>
    </Row>
  )
}

export default PasswordCard
